import * as actionTypes from '../constant/download';
import * as req from '../request/download';

/**
 * 获得pos机的数据
 */
export function getCxmData() {
  return async (dispatch) => {
    const res = await req.getCxmData();
    if (res) {
      dispatch({ type: actionTypes.DOWNLOAD_CXM, payload: res });
    }
  };
}
/**
 * 获得pos机的数据
 */
export function getPosData() {
  return async (dispatch) => {
    const res = await req.getPosData();
    if (res) {
      dispatch({ type: actionTypes.DOWNLOAD_POS, payload: res });
    }
  };
}
